
if (typeof Function.prototype.bind === 'undefined') {
  Function.prototype.bind = function (context) {
    var params = ([]).slice.call(arguments, 1);
    var fn = this;
    return function () {
      var allParams = params.concat(([]).slice.call(arguments, 0));
      return fn.apply(context, allParams);
    };
  };
};
module.exports = function anonymous(locals, escape, include, rethrow
/*``*/) {
escape = escape || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ;  if (picData && (picData.length > 1)) {
    ; __append("\n\n<div class=\"news-phos news-phos-")
    ; if (picData.length == 2 || picData.length == 4) {
    ; __append("2")
    ; } else {
    ; __append("3")
    ; }
    ; __append("\">\n    ")
    ;  for (var i = 0;i < picData.length; i++) {
    ; __append("\n        ")
    ; if (i < 9) {
    ; __append("\n        <div class=\"mod-imgdiv mod-imgdiv-")
    ; __append(escape(i))
    ; __append("\">\n            <div class=\"mod-imgdiv-bg\" data-index=\"")
    ; __append(escape(i))
    ; __append("\" data-mid=\"")
    ; __append(escape(mid))
    ; __append("\" style=\"background-image: url(")
    ; __append(escape(picData[i].purl))
    ; __append(" )\"></div>\n        </div>\n        ")
    ; }
    ; __append("\n    ")
    ; }
    ; __append("\n</div>\n")
    ; }
    ; __append("\n\n")
    ;  if (picData && picData.length ==1) {
    ; __append("\n<div class=\"news-phos news-phos-1\">\n    <div class=\"mod-imgdiv mod-imgdiv-0\" data-index=\"0\" data-mid=\"")
    ; __append(escape(mid))
    ; __append("\" ><img src=\"")
    ; __append(escape(picData[0].purl))
    ; __append("\" border=\"0\" /></div>\n</div>\n")
    ; }
    ; __append("\n\n")
  }
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// /Users/gebb/Desktop/live/modules/f.component.pic.mobile/app/modules/pic/pic.ejs
// module id = 417
// module chunks = 0